import React, { useState, useEffect } from 'react'
import { Region, transformRegionToMap } from 'msp-integrations'
import { default as BaseHotSpotCanvas } from '@molecules/HotSpotCanvas/HotSpotCanvas'

type HotSpotCanvasProps = {
  bgImage: string
  imageAlt: string
  headline: string
  bgColor: 'black' | 'white'
  regions: {
    id: string
    components: any[]
  }
  canvasSize: { height: number; width: number }
}

const HotSpotCanvas = ({
  bgImage,
  imageAlt,
  headline,
  bgColor = 'black',
  canvasSize,
  regions
}: HotSpotCanvasProps) => {
  const [activeIndex, setActiveIndex] = useState<number>(0)
  const [bubbleHeadline, setBubbleHeadline] = useState<string>('')
  const [activeContent, setActiveContent] = useState<any>(null)

  const bubblesArray = regions?.components || []

  useEffect(() => {
    setBubbleHeadline(bubblesArray?.[0]?.data?.headline)
    const bubbleContent = transformRegionToMap(bubblesArray?.[0]?.regions).get(
      'content'
    )
    setActiveContent(bubbleContent)
  }, [])

  const handleBubbleSelect = (headline: string, idx: number, content: any) => {
    setActiveIndex(idx)
    setBubbleHeadline(headline)
    setActiveContent(content)
  }

  const formattedIndex = (index: number): string =>
    `0${index.toString()}`.slice(-2)

  const content = (
    <div className='my-2 min-h-[10rem] md:my-2.5'>
      <Region region={activeContent} />
    </div>
  )

  return (
    <div className='relative h-fit w-full'>
      <BaseHotSpotCanvas
        activeIndex={activeIndex}
        activeItem={formattedIndex(activeIndex + 1)}
        bgImage={bgImage}
        imageAlt={imageAlt}
        content={content}
        headline={headline}
        bgColor={bgColor}
        imageDimensions={canvasSize}
        itemsLength={formattedIndex(bubblesArray?.length)}
        onItemSelect={handleBubbleSelect}
        regions={regions}
        title={bubbleHeadline}
      />
    </div>
  )
}

export default HotSpotCanvas
